import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Document, Page } from 'react-pdf';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import LoadingIndicator from 'Components/UI/LoadingIndicator';

const styles = theme => ({
  document: {
    backgroundColor: theme.palette.facet.accentGray,
    overflowY: 'auto',
  },
  loadingDocument: {
    backgroundColor: theme.palette.common.white,
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  page: {
    backgroundColor: theme.palette.common.white,
    marginBottom: theme.spacing(0.5),
  },
});

const PdfViewer = ({
  classes,
  href,
  parent,
}) => {
  const [numPagesInDoc, setNumPagesInDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [fileToLoad, setFileToLoad] = useState(null);

  useEffect(() => {
    if (href && href !== '') {
      setLoading(true);
      setFileToLoad({ url: href, withCredentials: true, httpHeaders: { Origin: window.origin } });
    }
  }, [href]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setLoading(false);
    setNumPagesInDoc(numPages);
  };

  if (parent === undefined || parent.width === 0 || fileToLoad === null) {
    return null;
  }

  return (
    <Document file={fileToLoad} onLoadSuccess={onDocumentLoadSuccess} onLoadError={(e) => displayErrorMessage(e, 'Failed to load pdf.')} className={loading ? classes.loadingDocument : classes.document} loading={<LoadingIndicator className={classes.loadingIndicator} />}>
      {Array.from(new Array(numPagesInDoc), (el, index) => (
        <Page key={`page_${index + 1}`} pageNumber={index + 1} className={classes.page} width={parent.width} />
      ))}
    </Document>
  );
};


PdfViewer.propTypes = {
  classes: PropTypes.object.isRequired,
  href: PropTypes.string.isRequired,
  parent: PropTypes.object.isRequired,
};

export default withStyles(styles)(PdfViewer);
